export default __webpack_public_path__ + "static/summer_containers83-6825310762074d0fdc99bb6385f38de6.webp";